// extracted by mini-css-extract-plugin
export default {"singleImage":"Artist_singleImage__++iDu"};